module.exports = __webpack_public_path__ + "img/icon-pencil.b4c3ed61.svg";